import type InboxRuleRequestStatus from "./schema/InboxRuleRequestStatus";
import type InboxRulesOptionState from "./schema/InboxRulesOptionState";
import initializeInboxRulesEditState from "../actions/helpers/initializeInboxRulesEditState";
import type MailBoxType from "owa-rules-option-common/lib/store/schema/MailBoxType";
import { createStore } from "owa-satcheljs";

const defaultStore: InboxRulesOptionState = {
    inboxRulesListState: {
        inboxRules: new Map(),
        inboxRuleIds: [],
        getInboxRuleRequestStatus: 0,
        getInboxRuleDiagnosticRequestStatus: 0,
        hasLoggedGetInboxRulesInformation: false,
        currentRunRuleFolderId: new Map(),
    },
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function initializeInboxRulesEditState called at module scope is not allowed. This may cause unwanted side effects. */
    inboxRulesEditState: initializeInboxRulesEditState(),
    messageClassifications: [],
    findFoldersRequestStatus: 0,
    contextMenuFolders: [],
    junkFolderDisplayName: "",
    mailBoxType: 0,
    attachedInboxRulesDialogState: null,
};

export const getStore: () => InboxRulesOptionState = createStore<InboxRulesOptionState>("inboxRulesOption", defaultStore);
export default getStore;
